import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslationModule } from '@core/translation/translation.module';
import { U2bOrderAssigneeFieldsComponent } from './u2b-order-assignee-fields.component';

@NgModule({
    declarations: [U2bOrderAssigneeFieldsComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        TranslationModule,
    ],
    exports: [U2bOrderAssigneeFieldsComponent],
})
export class U2bOrderAssigneeFieldsModule {}
